import { useCallback, useMemo } from 'react';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import useDefaultProperties from 'asset-actions-lib/hooks/useDefaultProperties';
import { ACTION_IDS } from 'asset-actions-lib/constants/actionIds';
import { OBJECT_TYPE } from 'asset-actions-lib/constants/objectTypes';
import AsyncObjectBuilderClient from './AsyncObjectBuilderClient';
import { jsx as _jsx } from "react/jsx-runtime";
export default function EditObjectPanel({
  onClose,
  onConfirm,
  crmObject
}) {
  const {
    defaultProperties
  } = useDefaultProperties({
    crmObject
  });
  const objectTypeId = useMemo(() => crmObject.objectTypeId, [crmObject]);
  const objectIdOrGuid = useMemo(() => getPropertyValue(crmObject, objectTypeId === OBJECT_TYPE.CAMPAIGN ? 'hs_origin_asset_id' : 'hs_object_id'), [crmObject, objectTypeId]);
  const handleClose = useCallback(({
    updatedObject
  }) => {
    if (updatedObject) {
      onConfirm(ACTION_IDS.EDIT, updatedObject);
    }
    onClose();
  }, [onClose, onConfirm]);
  return /*#__PURE__*/_jsx(AsyncObjectBuilderClient, {
    appName: "asset-actions-lib",
    objectTypeId: objectTypeId,
    use: "update",
    objectId: objectIdOrGuid,
    onClose: handleClose,
    defaultProperties: defaultProperties
  });
}